import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=57d223c8&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=57d223c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d223c8",
  null
  
)

export default component.exports